import React, { useState, useEffect } from "react";
import { Box, CssBaseline, Toolbar, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth } from "../Firebase/Firebase";

// Components
import DashboardAppBar from "./Components/DashboardAppBar";
import DashboardDrawer from "./Components/DashboardDrawer";
import DashboardContent from "./Components/DashboardContent";
import { menuItems } from "./Components/Menuitems";

export default function Dashboard() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [activePage, setActivePage] = useState("analytics");
  const [openSubMenu, setOpenSubMenu] = useState({});

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
      } else {
        navigate("/login");
      }
    });
    return () => unsubscribe();
  }, [navigate]);

  const handleDrawerOpen = () => setOpen(true);
  const handleDrawerClose = () => setOpen(false);
  const handleMobileDrawerToggle = () => setMobileOpen(!mobileOpen);

  const handleSubMenuClick = (page) => {
    setActivePage(page); // <-- BADLAV YAHAN HAI: Active page set karein
    if (!open) {
      handleDrawerOpen();
    }
    setOpenSubMenu((prev) => ({ ...prev, [page]: !prev[page] }));
  };

  const handleLogout = async () => {
    await signOut(auth);
    navigate("/login");
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />

      <DashboardAppBar
        open={open}
        user={user}
        handleDrawerOpen={handleDrawerOpen}
        handleMobileDrawerToggle={handleMobileDrawerToggle}
        handleLogout={handleLogout}
      />

      <DashboardDrawer
        open={open}
        mobileOpen={mobileOpen}
        handleDrawerClose={handleDrawerClose}
        handleMobileDrawerToggle={handleMobileDrawerToggle}
        menuItems={menuItems}
        activePage={activePage}
        setActivePage={setActivePage}
        openSubMenu={openSubMenu}
        handleSubMenuClick={handleSubMenuClick}
      />

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          backgroundColor: "#f4f6f8",
          minHeight: "100vh",
        }}
      >
        <Toolbar />
        {user ? (
          <DashboardContent activePage={activePage} user={user} />
        ) : (
          <Typography>Loading...</Typography>
        )}
      </Box>
    </Box>
  );
}
